import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentAttendanceTab } from '@features/student-page/components/StudentAttendanceTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/attendance/')({
    component: RouteComponent,
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title="Failed to load student attendance overview">
            <Suspense fallback={<LoadingIndicator resource="attendance overview" />}>
                <StudentAttendanceTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
